<template>
    <div>

        <!--页面名称、操作按钮开始-->
        <el-row>
            <div class="left-justifying"><h3>物品出入记录</h3></div>

            <div class="right-justifying">
                <!--<el-button type="info" plain size="small" @click="exportFunc"><i
                        class="fa fa-plus-circle"></i> 物品进出记录下载
                </el-button>-->
            </div>
        </el-row>
        <!--页面名称、操作按钮结束-->

        <div class="panel">
            <div class="panel-body">

                <el-row>

                    <div class="advanced-search-location">
                        <AthubDropDownSearch :model="searchFormData" formWidth=800 size="mini"
                                             collapseTags multiple>

                            <el-form :model="searchFormData" label-width="80px">
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="物品进出日期从">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchFormData.equipmentInOut.startdate"
                                                    type="date"
                                                    placeholder="物品进出日期从">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="物品进出日期到">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchFormData.equipmentInOut.enddate"
                                                    type="date"
                                                    placeholder="物品进出日期到">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>

                        </AthubDropDownSearch>
                    </div>

                    <el-tabs v-model="activeTab">
                        <el-tab-pane label="列表" name="in_out_list">

                            <el-row class="bottom20">
                                <el-table :data="tableData" stripe style="width: 100%">

                                    <el-table-column prop="equipmentInOut.dept" :formatter="formatDept" label="数据中心">
                                        <template slot="header" slot-scope="scope">
                                            数据中心<br>
                                            <DeptSelect size="mini" ref="deptSelect" allowAll="true" multiple="true"
                                                        v-model="searchFormData.equipmentInOut.depts"
                                                        @fetchAllDepts="fetchAllDepts">
                                            </DeptSelect>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.inouttime" :formatter="formatInoutDate"
                                                     label="物品进/出日期">
                                        <template slot="header" slot-scope="scope">
                                            物品进/出日期<br>
                                            <br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.applicantcomp" label="申请方">
                                        <template slot="header" slot-scope="scope">
                                            申请方<br>

                                            <el-select filterable
                                                       clearable
                                                       size="mini"
                                                       v-model="searchFormData.equipmentInOut.applicantcomp"
                                                       placeholder="请选择">
                                                <el-option
                                                        v-for="item in companyList"
                                                        :key="item.company"
                                                        :label="item.name"
                                                        :value="item.company">
                                                </el-option>
                                            </el-select>

                                            <!--<el-input size="mini" class="width70"
                                                      v-model="searchFormData.equipmentInOut.applicantcomp"></el-input>-->
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.type" :formatter="formatInoutType"
                                                     label="进出类型">
                                        <template slot="header" slot-scope="scope">
                                            进出类型<br>
                                            <el-select size="mini" v-model="searchFormData.equipmentInOut.type"
                                                       placeholder="请选择">
                                                <el-option label="" value=""></el-option>
                                                <el-option label="进" value="1"></el-option>
                                                <el-option label="出" value="2"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentname" label="物品类型">
                                        <template slot="header" slot-scope="scope">
                                            物品类型<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchFormData.equipmentname"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="nums" label="数量">
                                        <template slot="header" slot-scope="scope">
                                            数量<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                        <template slot="header" slot-scope="scope">
                                            单位<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.equinoutid" label="工单编号">
                                        <template slot="header" slot-scope="scope">
                                            工单编号<br>
                                            <el-input size="mini" v-model="searchFormData.equipmentInOut.equinoutid"
                                                      class="width70"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.applicant" label="申请人">
                                        <template slot="header" slot-scope="scope">
                                            申请人<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchFormData.equipmentInOut.applicant"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.tabulator" label="运维人员">
                                        <template slot="header" slot-scope="scope">
                                            运维人员<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchFormData.equipmentInOut.tabulator"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="equipmentInOut.reason"
                                                     label="物品进/出原因">
                                        <template slot="header" slot-scope="scope">
                                            物品进/出原因<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchFormData.equipmentInOut.reason"></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>

                            <el-row type="flex" class="row-bg" justify="end">
                                <el-pagination align="right" @size-change="handleSizeChange"
                                               @current-change="handleCurrentChange"
                                               :current-page="currentPage"
                                               :page-sizes="pageSizes" :page-size="pageSize"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="total">
                                </el-pagination>
                            </el-row>

                        </el-tab-pane>

                    </el-tabs>
                </el-row>

            </div>
        </div>
    </div>
</template>

<script>

    import DeptSelect from '@/components/dept'
    import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
    import DateUtil from '../../util/common/date'
    import {debounce} from '../../util'
    import EquipmentInOutServer from '../../api/equipment_in_out/index'
    import CompanyServer from '../../api/company/index'

    export default {

        name: 'equipment_io',

        components: {
            DeptSelect,
            AthubDropDownSearch,
        },

        data() {
            return {

                activeTab: "in_out_list",

                deptList: [],
                companyList: [],

                searchFormData: {
                    equipmentname: '',
                    nums: '',
                    unit: '',
                    equipmentInOut: {
                        depts: [],
                        inouttime: '',
                        applicantcomp: '',
                        type: '',
                        equinoutid: '',
                        applicant: '',
                        tabulator: '',
                        reason: '',
                        startdate: null,
                        enddate: null,
                    },

                },

                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageSizes: [10, 25, 50, 100],

                tableData: [],


            }
        },

        methods: {

            fetchAllDepts(depts) {
                this.deptList = depts;
            },

            formatInoutType(row, column) {
                if (row.equipmentInOut.type == '1') {
                    return '进';
                } else {
                    return '出';
                }
            },

            formatDept(row, column) {
                let deptDesc = '';
                this.deptList.forEach(e => {
                    if (row.equipmentInOut.dept == e.id) {
                        deptDesc = e.name;
                    }
                });
                return deptDesc;
            },

            formatInoutDate(row, column) {
                return new Date(row.equipmentInOut.inouttime).Format('yyyy-MM-dd');
            },

            exportFunc() {

            },

            queryTable() {

                let params = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }
                this.searchFormData.equipmentInOut.statusList = ['CLOSED'];
                params = {...this.searchFormData, ...params};
                EquipmentInOutServer.equipmentIoInfo.page(params, {
                    headers: {
                        orgId: localStorage.getItem("authorg"),
                        sites: localStorage.getItem("authsites"),
                    }
                }).then((responseBody) => {
                    this.tableData = responseBody.data.data.pageData;
                    this.total = responseBody.data.data.total;
                })

            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

        },

        watch: {

            searchFormData: {
                immediate: true,
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    if (this.searchFormData.equipmentInOut.startdate != null) {
                        this.searchFormData.equipmentInOut.startdate = new Date(this.searchFormData.equipmentInOut.startdate).Format('yyyy-MM-dd hh:mm:ss');
                    }
                    if (this.searchFormData.equipmentInOut.enddate != null) {
                        this.searchFormData.equipmentInOut.enddate = new Date(this.searchFormData.equipmentInOut.enddate).Format('yyyy-MM-dd hh:mm:ss');
                    }
                    this.currentPage = 1;    //查询条件变动，页码重置
                    this.queryTable();
                }, 500)
            },

        },

        mounted() {

            CompanyServer.company.getAllValidList().then(responseBody => {
                this.companyList = responseBody;
            });

        },
    }

</script>